/* src/app/components/payroll/corrections/correction-line-filter/correction-line-filter.component.css */
.filter-row {
  align-items: flex-end;
}
.filter-actions {
  display: flex;
  gap: 8px;
}
.field-header {
  font-size: 12px;
}
.error-message {
  color: red;
  font-size: 12px;
  margin-top: 4px;
}
/*# sourceMappingURL=correction-line-filter.component-W6FW2DNL.css.map */
